import React, {useEffect, useState} from 'react';
import DoneIcon from '@material-ui/icons/Done';
import {withRouter} from "react-router-dom";
import client from "../lib/api/client";

const ThanksPage = ({ history }) => {
    const [seconds, setSeconds] = useState(10);

    useEffect(() => {
        const interval = setInterval(() => {
            setSeconds(prevSeconds => prevSeconds - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (seconds <= 0) {
            // 로그아웃 동작을 수행합니다.
            handleButtonClick();
        }
    }, [seconds]);
    const handleButtonClick = () => {
        client.post('/kognr/logout').then(response => {
            if (response.data.success) {
                localStorage.clear();
                history.replace("/");
            }
        }).catch((error) => {
        });
    };

    return (
        <>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%', backgroundColor: '#F9EBDE'}}>
                <h1 style={{fontSize: '5rem'}}>THANK YOU!</h1>
                <DoneIcon style={{fill: '#24b663', fontSize: '150px', fontWeight: 'bold'}} />
                <p style={{color: '#000000', fontSize: '1.5rem', fontWeight: 'bold'}}>
                    질문지 작성에 협조해 주셔서 감사합니다.
                </p>
                <h1>로그아웃까지 남은 시간: {seconds}초</h1>
                <button className="button-68" role="button" onClick={handleButtonClick}>확인</button>
                <p style={{color: '#000000', fontSize: '1.2rem', marginTop: '120px'}}>
                    &copy; 2026 EY Han Young | People Advisory Services. All Rights Reserved
                </p>
            </div>
        </>
    )
};

export default withRouter(ThanksPage);

